import { createSelector } from 'reselect';
import api from './api';
import { combineReducers } from '../../node_modules/redux';

const stateEventSelector = (state) => state.events;

export const selector = createSelector(
  [stateEventSelector],
  (events) => {
    return { ...events };
  },
);

const EVENTS_FETCH_ALL_REQUEST = 'EVENTS_FETCH_ALL_REQUEST';
const EVENTS_FETCH_ALL_SUCCESS = 'EVENTS_FETCH_ALL_SUCCESS';
const EVENTS_FETCH_ALL_FAILURE = 'EVENTS_FETCH_ALL_FAILURE';

const EVENTS__FETCH_SINGLE_REQUEST = 'EVENTS__FETCH_SINGLE_REQUEST';
const EVENTS__FETCH_SINGLE_SUCCESS = 'EVENTS__FETCH_SINGLE_SUCCESS';
const EVENTS__FETCH_SINGLE_FAILURE = 'EVENTS__FETCH_SINGLE_FAILURE';

const EVENTS__CREATE_REQUEST = 'EVENTS__CREATE_REQUEST';
const EVENTS__CREATE_SUCCESS = 'EVENTS__CREATE_SUCCESS';
const EVENTS__CREATE_FAILURE = 'EVENTS__CREATE_FAILURE';

const EVENTS__UPDATE_REQUEST = 'EVENTS__UPDATE_REQUEST';
const EVENTS__UPDATE_SUCCESS = 'EVENTS__UPDATE_SUCCESS';
const EVENTS__UPDATE_FAILURE = 'EVENTS__UPDATE_FAILURE';

const EVENTS__DELETE_REQUEST = 'EVENTS__DELETE_REQUEST';
const EVENTS__DELETE_SUCCESS = 'EVENTS__DELETE_SUCCESS';
const EVENTS__DELETE_FAILURE = 'EVENTS__DELETE_FAILURE';

const EVENT__RESET_NEW_EVENT = 'EVENT__RESET_NEW_EVENT';
const EVENT__UPDATE_NEW_EVENT = 'EVENT__UPDATE_NEW_EVENT';
const EVENT__UPDATE_EDIT_EVENT = 'EVENT__UPDATE_EDIT_EVENT';

const EVENTS__UPDATE_INVENTORY_REQUEST = 'EVENTS__UPDATE_INVENTORY_REQUEST';
const EVENTS__UPDATE_INVENTORY_SUCCESS = 'EVENTS__UPDATE_INVENTORY_SUCCESS';
const EVENTS__UPDATE_INVENTORY_FAILURE = 'EVENTS__UPDATE_INVENTORY_FAILURE';

const EVENTS__CREATE_RESERVATION_REQUEST = 'EVENTS__CREATE_RESERVATION_REQUEST';
const EVENTS__CREATE_RESERVATION_SUCCESS = 'EVENTS__CREATE_RESERVATION_SUCCESS';
const EVENTS__CREATE_RESERVATION_FAILURE = 'EVENTS__CREATE_RESERVATION_FAILURE';

const EVENTS__PUBLISH_REQUEST = 'EVENTS__PUBLISH_REQUEST';
const EVENTS__PUBLISH_SUCCESS = 'EVENTS__PUBLISH_SUCCESS';
const EVENTS__PUBLISH_FAILURE = 'EVENTS__PUBLISH_FAILURE';

const EVENTS__DOWNLOAD_REPORT_REQUEST = 'EVENTS__DOWNLOAD_REPORT_REQUEST';
const EVENTS__DOWNLOAD_REPORT_SUCCESS = 'EVENTS__DOWNLOAD_REPORT_SUCCESS';
const EVENTS__DOWNLOAD_REPORT_FAILURE = 'EVENTS__DOWNLOAD_REPORT_FAILURE';

const EVENT__ADD_BLOCK_NEW_EVENT = 'EVENT__ADD_BLOCK_NEW_EVENT';
const EVENT__UPDATE_BLOCK_NEW_EVENT = 'EVENT__UPDATE_BLOCK_NEW_EVENT';
const EVENT__ADD_BLOCK_EDIT_EVENT = 'EVENT__ADD_BLOCK_EDIT_EVENT';
const EVENT__UPDATE_BLOCK_EDIT_EVENT = 'EVENT__UPDATE_BLOCK_EDIT_EVENT';

const initialState = {
  events: {},
  newEvent: {
    participatingFacilities: [],
    blocks: [],
  },
};

export const actionCreators = {
  resetEvent: () => ({ type: EVENT__RESET_NEW_EVENT }),
  updateNewEvent: (event) => ({ type: EVENT__UPDATE_NEW_EVENT, event }),
  updateEditEvent: (event) => ({ type: EVENT__UPDATE_EDIT_EVENT, event }),
  addNewBlock: (event) => ({ type: EVENT__ADD_BLOCK_NEW_EVENT, event }),
  updateNewBlock: (event, block) => ({ type: EVENT__UPDATE_BLOCK_NEW_EVENT, event, block }),
  addEditBlock: (event) => ({ type: EVENT__ADD_BLOCK_EDIT_EVENT, event }),
  updateEditBlock: (event, block) => ({ type: EVENT__UPDATE_BLOCK_EDIT_EVENT, event, block }),
  createReservation: (reservation) =>
    api({
      types: [EVENTS__CREATE_RESERVATION_REQUEST, EVENTS__CREATE_RESERVATION_SUCCESS, EVENTS__CREATE_RESERVATION_FAILURE],
      uri: '/api/reservation',
      config: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reservation),
      },
      payload: reservation,
      sendJwtBearer: false,
    }),
  getEvent: (eventId) =>
    api({
      types: [EVENTS__FETCH_SINGLE_REQUEST, EVENTS__FETCH_SINGLE_SUCCESS, EVENTS__FETCH_SINGLE_FAILURE],
      uri: `/api/events/${eventId}`,
      config: {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
      sendJwtBearer: false,
    }),
  getEvents: () =>
    api({
      types: [EVENTS_FETCH_ALL_REQUEST, EVENTS_FETCH_ALL_SUCCESS, EVENTS_FETCH_ALL_FAILURE],
      uri: '/api/events',
      config: {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
      sendJwtBearer: false,
    }),
  createEvent: (event) =>
    api({
      types: [EVENTS__CREATE_REQUEST, EVENTS__CREATE_SUCCESS, EVENTS__CREATE_FAILURE],
      uri: '/api/events',
      config: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(event),
      },
      payload: event,
      sendJwtBearer: true,
    }),
  updateEvent: (event) =>
    api({
      types: [EVENTS__UPDATE_REQUEST, EVENTS__UPDATE_SUCCESS, EVENTS__UPDATE_FAILURE],
      uri: '/api/events',
      config: {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(event),
      },
      payload: event,
      sendJwtBearer: true,
    }),
  deleteEvent: (event) =>
    api({
      types: [EVENTS__DELETE_REQUEST, EVENTS__DELETE_SUCCESS, EVENTS__DELETE_FAILURE],
      uri: '/api/events',
      config: {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(event),
      },
      payload: event,
      sendJwtBearer: true,
    }),
  publishEvent: (event) =>
    api({
      types: [EVENTS__PUBLISH_REQUEST, EVENTS__PUBLISH_SUCCESS, EVENTS__PUBLISH_FAILURE],
      uri: '/api/events/publish',
      config: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(event),
      },
      payload: event,
      sendJwtBearer: true,
    }),
  updateInventory: (event) =>
    api({
      types: [EVENTS__UPDATE_INVENTORY_REQUEST, EVENTS__UPDATE_INVENTORY_SUCCESS, EVENTS__UPDATE_INVENTORY_FAILURE],
      uri: '/api/events/inventory',
      config: {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(event),
      },
      payload: event,
      sendJwtBearer: true,
    }),
  downloadEventReport: (id, summary = false) =>
    api({
      types: [EVENTS__DOWNLOAD_REPORT_REQUEST, EVENTS__DOWNLOAD_REPORT_SUCCESS, EVENTS__DOWNLOAD_REPORT_FAILURE],
      uri: summary ? `/api/events/${id}/report/summary` : `/api/events/${id}/report`,
      config: {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
      sendJwtBearer: true,
    }),
};

const events = (state = initialState.events, action) => {
  switch (action.type) {
    case EVENTS__CREATE_SUCCESS:
      return { ...state, [action.response.id]: action.response };
    case EVENTS_FETCH_ALL_SUCCESS:
      return {
        ...state,
        ...action.response.reduce((obj, item) => {
          obj[item.id] = item;
          return obj;
        }, {}),
      };
    case EVENTS__UPDATE_INVENTORY_SUCCESS:
      return { ...state, [action.response.id]: action.response };
    case EVENTS__UPDATE_SUCCESS:
      return { ...state, [action.response.id]: action.response };
    case EVENT__UPDATE_EDIT_EVENT:
      return { ...state, ...{ [action.event.id]: action.event } };
    case EVENTS__FETCH_SINGLE_SUCCESS:
      return { ...state, ...{ [action.response.id]: action.response } };
    case EVENT__ADD_BLOCK_EDIT_EVENT: {
      const newState = { ...state };
      const newEvt = { ...newState[action.event.id] };
      newState[action.event.id] = { ...newEvt, blocks: [...(newEvt.blocks || []), { id: (newEvt.blocks || []).length }] };
      return { ...newState };
    }
    case EVENT__UPDATE_BLOCK_EDIT_EVENT: {
      const newState = { ...state };
      const newEvt = { ...newState[action.event.id] };
      var blocks = [...(newEvt.blocks || [])];
      const idx = blocks.findIndex((b) => b.id === action.block.id);
      blocks[idx] = action.block;
      newState[action.event.id] = { ...newEvt, blocks };
      return { ...newState };
    }
    case EVENTS__PUBLISH_SUCCESS: {
      const newState = { ...state };
      const evt = { ...newState[action.payload.id] };
      evt.isPublished = true;
      newState[action.payload.id] = { ...evt };
      return { ...newState };
    }
    case EVENTS__DELETE_SUCCESS: {
      const newState = { ...state };
      delete newState[action.payload.id];
      return { ...newState };
    }
    default:
      return { ...state };
  }
};

const newEvent = (state = initialState.newEvent, action) => {
  switch (action.type) {
    case EVENT__UPDATE_NEW_EVENT:
      return { ...state, ...action.event };
    case EVENT__RESET_NEW_EVENT:
      return { ...initialState.newEvent };
    case EVENT__ADD_BLOCK_NEW_EVENT:
      return { ...state, blocks: [...(state.blocks || []), { id: (state.blocks || []).length }] };
    case EVENT__UPDATE_BLOCK_NEW_EVENT: {
      var blocks = [...(state.blocks || [])];
      const idx = blocks.findIndex((b) => b.id === action.block.id);
      blocks[idx] = action.block;
      return { ...state, blocks };
    }
    default:
      return { ...state };
  }
};

export const reducer = combineReducers({
  events,
  newEvent,
});
